import { finish, error } from '../../../modules/betslip/actions/get-referred-betslip';

import api from '../../../api';

export function request(dispatch, { id }) {
    api.get('/customers/' + id + '/referred-betslip', void 0, { cache: true }).then(
        ({ bets, expiresAt, assignee, when }) => dispatch(finish({ id, bets, expiresAt, assignee, when })),
        ({ errors }) => dispatch(error(id, errors))
    );
}
